<template>
  <div
    class="loading"
    v-bind:class="{ 'loading--full' : full }"
  >
    <div class="loading--spinner"></div>
  </div>
</template>

<script>
  export default {
    name: 'Loading',
    props: [
      'full'
    ]
  }
</script>

<style lang="scss">
  .loading {
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;

    &--spinner {
      border: 6px solid var(--blue-light);
      border-radius: 50%;
      border-top: 6px solid var(--blue);
      width: 50px;
      height: 50px;
      -webkit-animation: spin 1s linear infinite;
      animation: spin 1s linear infinite;
    }

    @-webkit-keyframes spin {
      0% { -webkit-transform: rotate(0deg); }
      100% { -webkit-transform: rotate(360deg); }
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  }  

  .loading--full {
    width: 100%;
    height: calc(100vh - 120px);

    .loading--spinner {
      border: 6px solid var(--white);
      border-top: 6px solid var(--blue);
    }
  }
</style>